/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { useLocalization } from '@/data/Localization';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { FC } from 'react';

export const NotAvailable: FC<{ message: string }> = ({ message }) => {
	
	const { Actions : { ContinueShopping } } = useLocalization('Common');

	return (
		<Stack rowGap={2}>
			<Paper>
				<Typography p={3} variant="body1" key={0} fontWeight='bold'>{message}</Typography>
			</Paper>
			<Button variant='outlined' sx={{width:'fit-content'}} href='/'>{ContinueShopping.t()}</Button>
		</Stack>
	);
};
